module.exports = require("@bigcommerce/script-loader");